/**
 * @ngdoc overview
 * @name googleads.service:GoogleAdsService
 */
'use strict';
define(['app'], function (app) {
    app.service('GoogleAdsService', GoogleAdsService);
    GoogleAdsService.$inject = ['API', '__env'];

    function GoogleAdsService(API, __env) {
        var apiVersion = __env.apiVersion2 || 'v2';
        var apiBaseUrl = __env.apiGateway + '/api/' + apiVersion + '/';
        var apiPath = apiBaseUrl + __env.googleAdsAPI;

        /**
         * Languages, locations and networks used by the keyword planner.
         * @returns {Promise}
         */
        this.getReferenceData = function () {
            return API.get(apiPath + '/reference-data', true, true);
        };

        /**
         * Keyword Planner: keyword ideas for the given seeds.
         * @param {Object} filters keywords, language, location, network
         * @returns {Promise}
         */
        this.getKeywordIdeas = function (filters) {
            return API.post(apiPath + '/keyword-ideas', filters, true, true);
        };

        /**
         * Keyword Planner: historical metrics of already known keywords.
         * @param {Object} filters keywords, language, location, network
         * @returns {Promise}
         */
        this.getHistoricalMetrics = function (filters) {
            return API.post(apiPath + '/historical-metrics', filters, true, true);
        };

        /**
         * Call the Google Ads lookup endpoint.
         * @param {Object} filters optional params sent as query string (keyword, geo, ...)
         * @returns {Promise}
         */
        this.lookup = function (filters) {
            return API.get(apiPath + '/lookup', {params: filters || {}}, true, true);
        };
    }
});
